import { environment as env } from 'src/environments/environment';

export class BaseProperties {
  public static BASE_URL = env.api.BASE_URL;

  public static BASE_CONIFIG_URL = 'https://sfx-base-artifacts.s3.amazonaws.com/dev/configs/';

  public static SEAMID_URL = env.api.SEAMID_URL;

  public static DEV_BASE_URL = 'http://localhost:8195/api/v1/seamid-node';

  public static BIOREGISTA_URL = env.api.BIOREGISTRA_URL;

  public static EMAIL_TEMPLATE_BASE_URL = env.api.EMAIL_TEMPLATE_BASE_URL;
}

